import { validationRules } from '../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../@types/validation-types'
import { useManualAndInternationalAddress } from '../../../../../services/validation/flow/defaultSchemas'

export const agentWaitingListApartmentRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    price: validationRules.price,
  },
  description: {
    adTitle: validationRules.adTitle,
  },
}
